const TechnicalLV9 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>Ziemas riepas un drošība</strong></span></p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Gaisa temperatūrai nokrītot zem +7&deg;C, ziemas riepas piedāvā lielāku drošību un labāku ekonomiju. Ekstremāliem ziemas ceļa apstākļiem paredzētas mīkstā sastāva jeb frikcijas riepas un riepas ar radzēm. Šādas riepas pieejamas tirdzniecībā tikai tajos reģionos, kur tās ir atļauts izmantot ceļu satiksmē. Pārvietojoties ar automobili pa dažādu reģionu ceļiem, noteikti ir jāņem vērā vietējā likumdošana par noteiktu riepu vai citu palīglīdzekļu, piemēram, riteņu ķēžu izmantošanu.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Maksimālais ātrums ziemas riepām</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ziemas riepām parasti ir zemāks pieļaujamais maksimālais ātrums. Tāpēc gadījumā, ja šis pieļaujamais ātrums ir mazāks nekā paša automobiļa maksimāli sasniedzamais, tad ieteicams šādu informāciju izvietot autovadītāja tiešās redzamības zonā uz instrumentu paneļa uzlīmes veidā, lai tas netiktu pārsniegts.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Riepu kombinēšana</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vasaras un ziemas riepu kombinēšana uz dažādām vieglo automobiļu asīm nav ieteicama.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Protektora dziļums</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ziemas riepām ir jāatbilst noteiktām prasībām, turklāt minimāli pieļaujamais protektora dziļums 1,6 mm nav atbilstošs. Tāpēc ziemas riepām protektora dziļumam ir jābūt lielākam par 4 mm. Drošības labad rekomendējam mainīt ziemas riepas vēl pirms protektora dziļums ir sasniedzis minimāli pieļaujamos 4 mm. Tādas riepas, ja vien nav aprīkotas ar radzēm, var tikt izmantotas arī vasaras periodā.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Saķere un marķējums</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vislabāko saķeri ziemas ceļa apstākļos automobilis iegūst, ja visi riteņi ir aprīkoti ar īstām ziemas riepām.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>M+S</strong> marķējums nozīmē <strong>mud and snow</strong> jeb dubļiem un sniegam paredzētu riepu apzīmējumu. Savukārt sniegpārsliņas simbols (3PMSF) norāda, ka riepa ir testēta un atbilst noteiktiem ziemas veiktspējas kritērijiem.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Riepas ar radzēm</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Latvijā radzētās riepas ir atļauts izmantot <strong>no 1.oktobra līdz 30.aprīlim</strong>, savukārt automobiļiem, kuru pilna masa nepārsniedz 3,5 t, laika periodā <strong>no 1.decembra līdz 1.martam</strong> ir jābūt aprīkotiem ar ziemas riepām.</p>
        </div>
    );
};

export default TechnicalLV9;


